export default {
  'Filters.allSources': 'All sources',
}
